import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useToken } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { IconButton } from '@hub/button';
import { ChevronLeftSmallIcon, ChevronRightSmallIcon } from '@hub/icon';
import { Imposter } from '@hub/imposter';
import { Reel } from '@hub/reel';
import React from 'react';
// useMobileBreakpoint looks unavoidable here due to the props composition
// and complex logic
// eslint-disable-next-line no-restricted-syntax
import useMobileBreakpoint from '../../helpers/use-mobile-breakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LinkReel = props => {
  const isMobileBreakpoint = useMobileBreakpoint();
  const isMobile = props.isMobile === undefined ? isMobileBreakpoint : props.isMobile;
  const surfaceTeriary = useToken('colors', 'surfaceTertiary');
  return /*#__PURE__*/_jsx(Reel, _objectSpread(_objectSpread({}, props), {}, {
    visibleFrames: 0,
    sx: _objectSpread(_objectSpread({}, props.sx), {}, {
      marginLeft: ['-spacing-lg', '-spacing-lg', 0],
      marginRight: ['-spacing-lg', '-spacing-lg', 0],
      scrollbarWidth: 'none'
    }, isMobile && {
      width: 'auto',
      paddingRight: 'spacing-lg',
      paddingLeft: 'spacing-lg',
      WebkitMaskImage: "linear-gradient(\n                to right,\n                rgba(0,0,0,0) 2px, rgba(0,0,0,1) 24px,\n                rgba(0,0,0,1) calc(100% - 24px), rgba(0,0,0,0) calc(100% - 2px)\n              )"
    }),
    renderControls: _ref => {
      let {
        scrollPosition,
        children,
        prevComponentProps,
        nextComponentProps
      } = _ref;
      return /*#__PURE__*/_jsx(Imposter, {
        impose: !isMobile && scrollPosition !== 'full' ? /*#__PURE__*/_jsx(Box, {
          sx: {
            backgroundColor: surfaceTeriary,
            height: '100%',
            paddingLeft: 'spacing-sm',
            visibility: scrollPosition === 'end' ? 'hidden' : 'visible',
            zIndex: 1
          },
          "data-id": "link-reel_index_LinkReel_Box",
          children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, nextComponentProps), {}, {
            icon: /*#__PURE__*/_jsx(ChevronRightSmallIcon, {
              "data-id": "link-reel_index_LinkReel_ChevronRightSmallIcon"
            }),
            variant: "solid",
            colorScheme: "surfaceTertiaryWithIcon",
            size: "sm",
            "aria-label": "Scroll to next",
            "aria-hidden": "true",
            sx: {
              aspectRatio: '1',
              minWidth: 'unset',
              borderRadius: '50%',
              display: ['none', 'flex'],
              position: 'relative',
              top: 'calc(50% - 18px)'
            },
            "data-id": "link-reel_index_LinkReel_Box_IconButton"
          }))
        }) : /*#__PURE__*/_jsx(_Fragment, {}),
        position: "right",
        "data-id": "link-reel_index_LinkReel_Imposter",
        children: /*#__PURE__*/_jsx(Imposter, {
          impose: !isMobile && scrollPosition !== 'full' ? /*#__PURE__*/_jsx(Box, {
            sx: {
              backgroundColor: surfaceTeriary,
              height: '100%',
              paddingRight: 'spacing-sm',
              visibility: scrollPosition === 'start' ? 'hidden' : 'visible',
              zIndex: 1
            },
            "data-id": "link-reel_index_LinkReel_Box",
            children: /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({}, prevComponentProps), {}, {
              icon: /*#__PURE__*/_jsx(ChevronLeftSmallIcon, {
                "data-id": "link-reel_index_LinkReel_ChevronLeftSmallIcon"
              }),
              variant: "solid",
              colorScheme: "surfaceTertiaryWithIcon",
              size: "sm",
              "aria-label": "Scroll to previous",
              "aria-hidden": "true",
              sx: {
                aspectRatio: '1',
                minWidth: 'unset',
                borderRadius: '50%',
                display: ['none', 'flex'],
                position: 'relative',
                top: 'calc(50% - 18px)'
              },
              "data-id": "link-reel_index_LinkReel_Box_IconButton"
            }))
          }) : /*#__PURE__*/_jsx(_Fragment, {}),
          position: "left",
          "data-id": "link-reel_index_LinkReel_Imposter_Imposter",
          children: children
        })
      });
    },
    "data-id": "link-reel_index_LinkReel_Reel",
    children: props.children
  }));
};
export default LinkReel;